import axios from "axios";
import { servicePath } from "../../utility/data";


export const addStructure = async (structureData, accessToken) => {
    const payload = {
    "name": structureData.name,
    "included_in": structureData.inclusion.id,
    };
  
    try {
      const response = await axios.post(`${servicePath}/structure`, payload, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
  
      return response;
    } catch (error) {
      console.error('Error :', error);
      throw error;
    }
  };